import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import * as Highcharts from 'highcharts';
import * as Highcharts2 from 'highcharts/highstock';
import Tree from 'highcharts/modules/treemap';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
Tree(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ""
  }
});

@Component({
  selector: 'app-prject-wise-call-dashboard',
  templateUrl: './prject-wise-call-dashboard.component.html',
  styleUrls: ['./prject-wise-call-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PrjectWiseCallDashboardComponent implements OnInit {

  @ViewChild('table_1_1', { static: false }) table_1_1: ElementRef;
  @ViewChild('table_1_4', { static: false }) table_1_4: ElementRef;
  @ViewChild('table_1_6', { static: false }) table_1_6: ElementRef;
  @ViewChild('table_1_7', { static: false }) table_1_7: ElementRef;


  authToken = localStorage.getItem("token");
  // projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
  // userInfo: any = JSON.parse(localStorage.getItem("userInfo"))

  callsReportData: any = {};

  callDurationList: any[] = [];
  callDurationLabel: any[] = [];
  totalCallsList: any;
  verifiedCallList: any;
  leadSateReportAllStatus: any;
  weekdayReportAllStatus: any;
  weekDayCallReportList: any;
  weekDayTelecallerReportList: any;


  filterForm: FormGroup;
  isFilter: boolean = false;
  btnStatus: boolean = false;

  myDateRangePickerOptions = {
    dateFormat: 'dd-mm-yyyy'
  };

  currentDate = new Date();
  rowNowDate: any = new Date().toLocaleDateString();
  nowDate: any = new Date().toLocaleDateString().split('/');
  rowBackDate: any = new Date(this.currentDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
  backDate: any = new Date(this.currentDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString().split('/');

  //dateRange: any = { "beginDate": { "year": this.backDate[2], "month": this.backDate[1], "day": this.backDate[0] }, "endDate": { "year": this.nowDate[2], "month": this.nowDate[1], "day": this.nowDate[0] } }
  dateRange: any = ""

  clients: any[] = []
  selectedClients: any[] = []

  projects: any[] = []
  selectedProjects: any[] = []

  users: any[] = []
  selectedusers: any[] = []

  leadStateList: any[] = [
    { id: 'Fresh', name: 'Fresh' },
    { id: 'Cold', name: 'Cold' },
  ]
  selectedLeadStateList: any[] = []

  highcharts = Highcharts;


  displayedColumns: any[] = ['Previous-Status', 'Total', 'Fresh', 'Cold'];
  showCallDuration: boolean = false;
  userStatsColumn = {}


  weekdayTreeMapOptions_1_3: any = {};

  showWeekDayAllStatusChart: boolean = false;
  myArr1_3: any = []
  mySubArr1_3: any = []
  mySubArrChild1_3: any = []

  myTableArr1_4: any;

  // 1.5 Cold tree map


  callerChartJson: any = []
  freshColdTreeMapOptions_1_5: any = {

    series: [{
      type: 'treemap',
      layoutAlgorithm: 'squarified',
      allowDrillToNode: true,
      animationLimit: 1000,
      dataLabels: {
        enabled: false,
        format: '{point.name} : {point.value}',
      },
      levelIsConstant: false,
      levels: [{
        level: 1,
        dataLabels: {
          enabled: true
        },
        borderWidth: 3
      }],
      data: this.callerChartJson
    }],

    subtitle: {
      text: '',
      align: 'left'
    },

    title: {
      text: '',
      align: 'left'
    },

    credits: {
      enabled: false
    },

  };
  showColdFreshChart: boolean = false;
  myArr1_5: any = []
  mySubArr1_5: any = []


  weekdayColumns: any[] = ["Day", "Fresh","V-Under-Review", "Verified", "Appointment-Proposed", "V-Not-interested", "V-Not-Responding", "V-Not-Available", "Callback", "Wrong-Number", "Interested", "Not-Interested", "Not-Responding", "Not-Available", "Contacted", "Follow-UP", "Site-Visit", "Closed-Won", "V-Hold", "V-Interested", "V-Follow-UP", "V-SV-Drop", "V-SV-Done", "V-Booking-Done", "Other"];

  weekdayColumnsFreshCold: any[] = ['Day', 'Fresh', 'Cold', 'Null'];

  weekdayTelecallerColumns: any[] = ['Telecaller', 'Initiated-Calls', 'Connected-Calls', 'Fresh', 'V-Under-Review', 'Verified', 'Appointment-Proposed', 'V-Not-Interested', 'V-Not-Responding', 'V-Not-Available', 'Callback', 'Wrong-Number', 'Interested', 'Not-Interested', 'Not-Responding', 'Not-Available', 'Contacted', 'Follow-UP', 'Site-Visit', 'Closed-Won', 'V-Hold', 'V-Interested', 'V-Follow-UP', 'V-SV-Drop', 'V-SV-Done', 'V-Booking-Done'];

  myArr1_6: any = []


  parentDayMapping: any = {
    "Monday": "id_1",
    "Tuesday": "id_2",
    "Wednesday": "id_3",
    "Thursday": "id_4",
    "Friday": "id_5",
    "Saturday": "id_6",
    "Sunday": "id_7"
  };

  parentColorMapping: any = {
    "Monday": "34592ae",
    "Tuesday": "#4a537f",
    "Wednesday": "#529166",
    "Thursday": "#bd4a1f",
    "Friday": "#666666",
    "Saturday": "#a12d33",
    "Sunday": "#c6a135"
  };

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.setFilter()
    this.getClients()
    this.getProjects()
    this.getUsers()
    this.getLeadStatus()
    //this.filterSubmit()

    this.filterForm.get('dateRange').valueChanges.subscribe(res => {
      //console.log(res)
      if (res == null) {
        this.callsReportData = {}
      }
    })

  }


  clearDate(): void {
    //alert('hi')
  }


  setFilter() {
    this.filterForm = this._fb.group({
      dateRange: [[], Validators.compose([Validators.required])],
      //dateRange: [[]],
      client: [[]],
      project: [[]],
      user: [[]],
      leadState: [[]],
    })
  }

  filterSubmit() {

    this.isFilter = true;

    if (this.filterForm.invalid) {
      return false
    }

    this.getprojectCallsReport()

  }


  getprojectCallsReport() {

    let body = {
      //"date_range": [],
      "date_range": [this.filterForm.value.dateRange.beginDate.year + '-' + this.filterForm.value.dateRange.beginDate.month + '-' + this.filterForm.value.dateRange.beginDate.day, this.filterForm.value.dateRange.endDate.year + '-' + this.filterForm.value.dateRange.endDate.month + '-' + this.filterForm.value.dateRange.endDate.day],
      "client_ids": this.filterForm.value.client == null ? [] : this.filterForm.value.client,
      "project_ids": this.filterForm.value.project == null ? [] : this.filterForm.value.project,
      "user_ids": this.filterForm.value.user == null ? [] : this.filterForm.value.user,
      "lead_states": this.filterForm.value.leadState == null ? [] : this.filterForm.value.leadState,
    }

    this.serverService.getprojectCallsReport(body, this.authToken).subscribe(data => {
      //console.log(data)

    this.callsReportData = data;


      // start 1.1 Table data
      this.verifiedCallList = data.verified_call

      let totalFresh = 0;
      let totalCold = 0;
      let totalTotal = 0;

      for (const entry of data.verified_call) {
        totalFresh += entry["Fresh State Leads"];
        totalCold += entry["Cold State Leads"];
        totalTotal += entry["Total Leads"];
      }

      const totalRow = {
        "Lead Status Before Call": "Grand Total",
        "Fresh State Leads": totalFresh,
        "Cold State Leads": totalCold,
        "Total Leads": totalTotal
      };

      this.verifiedCallList.push(totalRow);


      // start 1.6 Table data

      this.callDurationList = []
      this.callDurationLabel = []

      for (let item of data.call_duration) {
        this.callDurationList.push(item['Total Calls'])
        this.callDurationLabel.push(item['duration_category'])
      }
      this.showCallDuration = true

      this.userStatsColumn = {
        chart: {
          type: 'bar'
        },
        title: {
          text: '',
          align: ''
        },
        subtitle: {
          text: '',
          align: ''
        },
        xAxis: {
          //categories: ['90+ sec', '61-90 sec', '31-60 sec', '1-30 sec', '0 sec'],
          categories: this.callDurationLabel,
          title: {
            text: null
          },
          gridLineWidth: 1,
          lineWidth: 0
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of Calls',
            align: 'middle'
          },
          labels: {
            overflow: 'justify'
          },
          gridLineWidth: 0
        },

        tooltip: {
          //valueSuffix: ' Calls',
          pointFormat: '<table><tr><td style = "color:{series.color};padding:0">{point.key}: </td>' +
            '<td style = "padding:0"><b>{point.y} Calls</b></td></tr></table>',
          shared: true,
          useHTML: true
        },

        plotOptions: {
          bar: {
            color: '#00C08D',
            borderRadius: '0%',
            dataLabels: {
              enabled: true
            },
            groupPadding: 0.1,
            pointWidth: 30
          }
        },

        credits: {
          enabled: false
        },

        legend: {
          enabled: false,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: false,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: false
        },

        series: [{
          //name: '',
          data: this.callDurationList
        }]
      }


      this.totalCallsList = data.total_calls;


      // For Tree Map 1.3
      this.weekdayReportAllStatus = data.weekday_report_all_status;

      this.myArr1_3 = []
      this.mySubArr1_3 = []
      const parentTransformedData = {};

      data.weekday_report_all_status.forEach(item => {
        const day = item["Weekday"];
        const totalCalls = item["Total Calls"];

        if (!parentTransformedData[day]) {
          parentTransformedData[day] = {
            "name": day,
            "id": this.parentDayMapping[day],
            "color": this.parentColorMapping[day],
            "value": totalCalls
          };
        } else {
          parentTransformedData[day]["value"] += totalCalls;
        }
      });

      this.mySubArr1_3 = Object.values(parentTransformedData);
      //console.log(this.mySubArr1_3);


      const childTransformedData = {};

      data.weekday_report_all_status.forEach(item => {
        const weekday = item.Weekday;
        const leadStatus = item["Lead Status"] || "other";
        const totalCalls = item["Total Calls"];

        // Generate the parent key if it doesn't exist
        if (!childTransformedData[weekday]) {
          childTransformedData[weekday] = {};
        }

        // Create or update the child objects
        childTransformedData[weekday][leadStatus] = (childTransformedData[weekday][leadStatus] || 0) + totalCalls;
      });

      // Flatten the transformed data into the desired format
      this.mySubArrChild1_3 = [];
      for (const weekday in childTransformedData) {
        for (const leadStatus in childTransformedData[weekday]) {
          const name = leadStatus === "other" ? leadStatus : leadStatus.trim();
          const value = childTransformedData[weekday][leadStatus];
          this.mySubArrChild1_3.push({
            parent: this.parentDayMapping[weekday],
            name: name,
            value: value
          });
        }
      }

      //console.log(this.mySubArrChild1_3);

      this.myArr1_3 = this.mySubArr1_3.concat(this.mySubArrChild1_3)
      //console.log(this.myArr1_3)

      this.showWeekDayAllStatusChart = true
      this.weekdayTreeMapOptions_1_3 = {

        series: [{
          type: 'treemap',
          layoutAlgorithm: 'squarified',
          allowDrillToNode: true,
          animationLimit: 1000,
          dataLabels: {
            enabled: false,
            format: '{point.name} : {point.value}',
          },
          levelIsConstant: false,
          levels: [{
            level: 1,
            dataLabels: {
              enabled: true
            },
            borderWidth: 3
          }],
          data: this.myArr1_3
          //data: this.weekdayCallerChartJson
        }],

        subtitle: {
          text: '',
          align: 'left'
        },

        title: {
          text: '',
          align: 'left'
        },

        credits: {
          enabled: false
        },

      };


      // For Tree Map 1.4
      this.myTableArr1_4 = []
      const myTableOBJ = {};
      data.weekday_report_all_status.forEach((item: any) => {
        const day: any = item.Weekday;
        const leadStatus: any = item["Lead Status"];
        const totalCalls: any = item["Total Calls"];

        // If 'day' doesn't exist in the transformed data, create it with 'other' initialized to 0
        if (!myTableOBJ[day]) {
          myTableOBJ[day] = { day, other: 0 };
        }

        // If 'leadStatus' is null or an empty string, add 'totalCalls' to 'other'
        if (!leadStatus || leadStatus === "") {
          myTableOBJ[day].other += totalCalls;

        } else if (
          leadStatus != "Fresh" &&
          leadStatus != "Verified" &&
          leadStatus != "V Not Interested" &&
          leadStatus != "V Not Responding" &&
          leadStatus != "V Not Available" &&
          leadStatus != "Interested" &&
          leadStatus != "Not Interested" &&
          leadStatus != "Not Responding" &&
          leadStatus != "Not Available" &&
          leadStatus != "Contacted" &&
          leadStatus != "Callback" &&
          leadStatus != "Follow Up" &&
          leadStatus != "Site Visit" &&
          leadStatus != "Closed/Won" &&
          leadStatus != "Wrong Number" &&
          leadStatus != "V Hold" &&
          leadStatus != "Appointment Proposed" &&
          leadStatus != "V Interested" &&
          leadStatus != "V Follow Up" &&
          leadStatus != "V SV Drop" &&
          leadStatus != "V SV Done" &&
          leadStatus != "V Booking done"
        ) {
          myTableOBJ[day].other += totalCalls;
        } else {
          // Otherwise, add 'leadStatus' as a property
          myTableOBJ[day][leadStatus] = totalCalls;
        }
      });

      // Convert the object into an array of objects
      this.myTableArr1_4 = Object.values(myTableOBJ);
      //console.log(this.myTableArr1_4)

      const totalRow_1_4 = { "day": "Grand Total" };
      for (let day in myTableOBJ) {
        for (let leadState in myTableOBJ[day]) {
          if (leadState !== "day") {
            totalRow_1_4[leadState] = (totalRow_1_4[leadState] || 0) + (myTableOBJ[day][leadState] || 0);
          }
        }
      }

      this.myTableArr1_4.push(totalRow_1_4);
      //console.log(this.myTableArr1_4)


      // For Tree Map 1.5
      this.leadSateReportAllStatus = data.lead_sate_report_all_status;


      this.myArr1_5 = []
      this.mySubArr1_5 = []

      for (let i = 0; i < data.lead_sate_report_all_status.length; i++) {

        if (data.lead_sate_report_all_status[i].lead_state == 'Fresh') {

          if (this.myArr1_5.length) {

            let mainItemFInd = this.myArr1_5.findIndex((item: any) => {
              return item.name == 'Fresh'
            })

            if (mainItemFInd != -1) {
              this.myArr1_5[mainItemFInd]['value'] = Number(this.myArr1_5[mainItemFInd]['value']) + Number(data.lead_sate_report_all_status[i]['Total Count'])
            } else {
              let myOBJ: any = {}
              myOBJ['name'] = data.lead_sate_report_all_status[i]['lead_state']
              myOBJ['id'] = "id_1"
              myOBJ['color'] = "#BF9724"
              myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
              this.myArr1_5.push(myOBJ)
            }

          } else {
            let myOBJ: any = {}
            myOBJ['name'] = data.lead_sate_report_all_status[i]['lead_state']
            myOBJ['id'] = "id_1"
            myOBJ['color'] = "#BF9724"
            myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
            this.myArr1_5.push(myOBJ)
          }

          let mySubOBJ: any = {}
          mySubOBJ.parent = "id_1"
          mySubOBJ.name = data.lead_sate_report_all_status[i]['Lead Status'] || 'Other'
          mySubOBJ.value = data.lead_sate_report_all_status[i]['Total Count']
          this.mySubArr1_5.push(mySubOBJ)

        }


        if (data.lead_sate_report_all_status[i].lead_state == 'Cold') {

          if (this.myArr1_5.length) {

            let mainItemFInd = this.myArr1_5.findIndex((item: any) => {
              return item.name == 'Cold'
            })

            if (mainItemFInd != -1) {
              this.myArr1_5[mainItemFInd]['value'] = Number(this.myArr1_5[mainItemFInd]['value']) + Number(data.lead_sate_report_all_status[i]['Total Count'])
            } else {
              let myOBJ: any = {}
              myOBJ['name'] = data.lead_sate_report_all_status[i]['lead_state']
              myOBJ['id'] = "id_2"
              myOBJ['color'] = "#25A69E"
              myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
              this.myArr1_5.push(myOBJ)
            }

          } else {
            let myOBJ: any = {}
            myOBJ['name'] = data.lead_sate_report_all_status[i]['lead_state']
            myOBJ['id'] = "id_2"
            myOBJ['color'] = "#25A69E"
            myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
            this.myArr1_5.push(myOBJ)
          }


          let mainItemFInd2 = this.mySubArr1_5.findIndex((item: any) => {
            return item.name == 'Other'
          })

          let mySubOBJ: any = {}
          mySubOBJ.parent = "id_2"
          mySubOBJ.name = data.lead_sate_report_all_status[i]['Lead Status'] || 'Other'
          mySubOBJ.value = data.lead_sate_report_all_status[i]['Total Count']
          this.mySubArr1_5.push(mySubOBJ)

        }

        if (data.lead_sate_report_all_status[i].lead_state == '' || !data.lead_sate_report_all_status[i].lead_state) {

          if (this.myArr1_5.length) {

            let mainItemFInd = this.myArr1_5.findIndex((item: any) => {
              return item.name == 'Other'
            })

            if (mainItemFInd != -1) {
              this.myArr1_5[mainItemFInd]['value'] = Number(this.myArr1_5[mainItemFInd]['value']) + Number(data.lead_sate_report_all_status[i]['Total Count'])
            } else {
              let myOBJ: any = {}
              myOBJ['name'] = 'Other'
              myOBJ['id'] = "id_3"
              myOBJ['color'] = "#25A675"
              myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
              this.myArr1_5.push(myOBJ)
            }

          } else {
            let myOBJ: any = {}
            myOBJ['name'] = 'Other'
            myOBJ['id'] = "id_3"
            myOBJ['color'] = "#25A675"
            myOBJ['value'] = data.lead_sate_report_all_status[i]['Total Count']
            this.myArr1_5.push(myOBJ)
          }

          let mySubOBJ: any = {}
          mySubOBJ.parent = "id_3"
          mySubOBJ.name = data.lead_sate_report_all_status[i]['Lead Status'] || 'Other'
          mySubOBJ.value = data.lead_sate_report_all_status[i]['Total Count']
          this.mySubArr1_5.push(mySubOBJ)

        }


      }
      this.myArr1_5 = this.myArr1_5.concat(this.mySubArr1_5)
      //console.log(this.myArr1_5)

      this.showColdFreshChart = true;
      this.freshColdTreeMapOptions_1_5 = {

        series: [{
          type: 'treemap',
          layoutAlgorithm: 'squarified',
          allowDrillToNode: true,
          animationLimit: 1000,
          dataLabels: {
            enabled: false,
            format: '{point.name} : {point.value}',
          },
          levelIsConstant: false,
          levels: [{
            level: 1,
            dataLabels: {
              enabled: true
            },
            borderWidth: 3
          }],
          //data: this.callerChartJson
          data: this.myArr1_5
        }],

        subtitle: {
          text: '',
          align: 'left'
        },

        title: {
          text: '',
          align: 'left'
        },

        credits: {
          enabled: false
        },

      };



      // For 1.6 Table

      this.weekDayCallReportList = data.week_day_call_report;

      const transformedData = {};

      data.week_day_call_report.forEach(item => {
        const day = item.Weekday;
        const leadState = item.lead_state || "null";

        if (!transformedData[day]) {
          transformedData[day] = { "day": day };
        }

        transformedData[day][leadState] = item.count;
      });


      this.myArr1_6 = Object.values(transformedData);

      const totalRow_1_6 = { "day": "Grand Total" };
      for (let day in transformedData) {
        for (let leadState in transformedData[day]) {
          if (leadState !== "day") {
            totalRow_1_6[leadState] = (totalRow_1_6[leadState] || 0) + (transformedData[day][leadState] || 0);
          }
        }
      }

      this.myArr1_6.push(totalRow_1_6);



      // For 1.7 Table

      this.weekDayTelecallerReportList = data.week_day_call_status;

      const totals = data.week_day_call_status.reduce((acc, entry) => {
        for (const key in entry) {
          if (key !== "Name") {
            acc[key] = (acc[key] || 0) + entry[key];
          }
        }
        return acc;
      }, {});


      totals.Name = "Grand Total";
      this.weekDayTelecallerReportList.push(totals);

    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }


  getClients() {
    this.serverService.clientsList(this.authToken).subscribe(data => {
      this.clients = data.client
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getProjects() {
    this.serverService.projectsList(this.authToken).subscribe(data => {
      this.projects = data
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getUsers() {
    this.serverService.usersList(this.authToken).subscribe(data => {
      this.users = data.users
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

  getLeadStatus() {
    this.leadStateList = [
      { id: 'Fresh', name: 'Fresh' },
      { id: 'Cold', name: 'Cold' },
    ]
  }


  filterLead() {
  }

  clear() {
    this.filterForm.reset()
    this.callsReportData = {}
    // this.setFilter()
    // this.filterForm.controls['date_range'].patchValue([])
    // this.filterForm.controls['client'].patchValue([])
    // this.filterForm.controls['project'].patchValue([])
    // this.filterForm.controls['user'].patchValue([])
    // this.filterForm.controls['leadState'].patchValue([])
    // [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]];
  }


  generateExcelFile(data: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Define the file name for the Excel file
    const fileName = name;

    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }

  exportAsExcel_1_1() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table_1_1.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '1-1-total-verified.xlsx');
  }


  exportAsExcel_1_4() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table_1_4.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '1-4-weekday-call-report.xlsx');
  }

  exportAsExcel_1_6() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table_1_6.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '1-2-weekday-call-report.xlsx');
  }

  exportAsExcel_1_7() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table_1_7.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '1-7-weekday-telecaller-report.xlsx');
  }


}
